import apiClient from './api';
import { Zuweisung, ZuweisungFilter, ConflictCheckResult } from '../types';
import { toDateKey } from '../utils/dateUtils';

export const zuweisungService = {
  getAllZuweisungen: async (filter?: ZuweisungFilter, page: number = 1, limit: number = 50): Promise<{ data: Zuweisung[]; meta: { total: number; page: number; limit: number } }> => {
    const params = new URLSearchParams();

    if (filter?.arztId) params.append('arztId', filter.arztId.toString());
    if (filter?.praxisId) params.append('praxisId', filter.praxisId.toString());
    if (filter?.zeitslot) params.append('zeitslot', filter.zeitslot);
    if (filter?.startDatum) params.append('startDatum', toDateKey(filter.startDatum));
    if (filter?.endDatum) params.append('endDatum', toDateKey(filter.endDatum));

    params.append('page', page.toString());
    params.append('limit', limit.toString());

    const response = await apiClient.get(`/zuweisungen?${params.toString()}`);
    return response.data;
  },

  getZuweisungById: async (id: number): Promise<Zuweisung> => {
    const response = await apiClient.get(`/zuweisungen/${id}`);
    return response.data;
  },

  createZuweisung: async (zuweisung: Omit<Zuweisung, 'id' | 'createdAt' | 'updatedAt' | 'arzt' | 'praxis'>): Promise<Zuweisung> => {
    const response = await apiClient.post('/zuweisungen', zuweisung);
    return response.data;
  },

  updateZuweisung: async (id: number, zuweisung: Partial<Omit<Zuweisung, 'id' | 'createdAt' | 'updatedAt' | 'arzt' | 'praxis'>>): Promise<Zuweisung> => {
    const response = await apiClient.put(`/zuweisungen/${id}`, zuweisung);
    return response.data;
  },

  deleteZuweisung: async (id: number): Promise<void> => {
    await apiClient.delete(`/zuweisungen/${id}`);
  },

  checkConflict: async (zuweisung: { arztId: number; datum: Date; zeitslot: string; praxisId: number; id?: number }): Promise<ConflictCheckResult> => {
    const payload = {
      arztId: zuweisung.arztId,
      praxisId: zuweisung.praxisId,
      datum: zuweisung.datum,
      zeitslot: zuweisung.zeitslot,
      currentZuweisungId: zuweisung.id,
    };
    const response = await apiClient.post('/zuweisungen/check-conflict', payload);
    return response.data;
  },
};
